import { render, staticRenderFns } from "./DataPersonsStatus.vue?vue&type=template&id=00e5fc20"
import script from "./DataPersonsStatus.vue?vue&type=script&lang=js"
export * from "./DataPersonsStatus.vue?vue&type=script&lang=js"
import style0 from "./DataPersonsStatus.vue?vue&type=style&index=0&id=00e5fc20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports